<template>
  <div class="stat-bar">
    <div class="stat-bar__inner">
      <div v-for="(item, index) in items" :key="index" class="stat-bar__item">
        <div class="stat-bar__icon">
          <span v-if="index === 0">🏆</span>
          <span v-else-if="index === 1">⚙️</span>
          <span v-else>🛠️</span>
        </div>
        <div class="stat-bar__content">
          <span class="stat-bar__label">{{ item.label }}</span>
          <span class="stat-bar__desc" v-if="index === 0">高标准品质保障</span>
          <span v-else-if="index === 1" class="stat-bar__desc">一站式全生命周期服务</span>
          <span v-else class="stat-bar__desc">快速响应，省心省力</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatBar',
  props: {
    items: { type: Array, required: true }
  }
}
</script>

<style lang="scss" scoped>
.stat-bar {
  background: linear-gradient(135deg, var(--color-dark) 0%, var(--color-primary-dark) 100%);
  padding: 1.75rem 2rem;
  border-radius: var(--radius-md);
  max-width: var(--max-width);
  margin: -3rem auto 0;
  position: relative;
  z-index: 10;
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.1);

  &__inner {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    align-items: center;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    color: #fff;
    text-align: left;

    &:not(:last-child) {
      border-right: 1px solid rgba(255, 255, 255, 0.15);
      padding-right: 1rem;
    }
  }

  &__icon {
    font-size: 2rem;
    background: rgba(255, 255, 255, 0.12);
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    flex-shrink: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }

  &__label {
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    color: #ffffff;
  }

  &__desc {
    font-size: 0.8rem;
    color: rgba(240, 253, 244, 0.75);
    font-weight: 500;
  }
}

@media (max-width: 992px) {
  .stat-bar {
    margin: 2rem auto 0;
    width: calc(100% - 2rem);

    &__inner {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    &__item {
      padding-bottom: 1rem;
      &:not(:last-child) {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
        padding-right: 0;
      }
    }
  }
}
</style>
